<template>
  <div style="clear: both">
    <v-autocomplete
      :model-value="modelValue"
      :label="$t('MOC_Type')"
      :items="mocTypes"
      :filter="customFilter"
      item-title="value"
      item-value="_id"
      variant="underlined"
      :readonly="readonly"
      v-on:update:model-value="updateValue"      
      :error-messages="errorMessages"
      :placeholder="$t('Rule_Required_MOCType')"
      dense
      density="comfortable"
      persistent-placeholder      
    ></v-autocomplete>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { multiPropertySort } from '@/common/arrayFunctions'
export default {
  emits: ['change', 'update:modelValue'],
  name: 'TypeField',
  props: {
    items: {
      type: Array
    },
    modelValue: {
      type: String,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    previousFormStatus: {
      type: Object
    },
    moc: {
      type: Object
    }
  },
  computed: {
    readonly: function () {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (this.moc.history.some((e) => e.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value)) {
            return true
          }

          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        default:
          return true
      }
      return true
    },
    mocTypes: function () {
      let sortBy = [{ prop: 'displayOrder', direction: 1 }]

      if (this.items != null) {
        return multiPropertySort(sortBy, this.items)
      }
      return null
    },
    errorMessages() {
      return this.modelValue && this.modelValue.trim() ? null : ' '
    }
  },
  methods: {
    updateValue: function (value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
      this.valueChanged(value)    
    },
    valueChanged: function (value) {
      // this.$emit('update:modelValue', value)
      this.$emit('change', value)      
    },
    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.toLowerCase().indexOf(searchText) === 0
    }
  }
}
</script>

<style scoped></style>
